module.exports = __webpack_public_path__ + "img/glazing_unknown.4b9d24f.svg";